import React from 'react'
import TableData from '../Includes/Table/TableData'
import IndemnitesMobileTitre from './IndemnitesMobileTitre'
import IndemnitesToolbarMobile from './IndemnitesToolbarMobile'
import IndemnitesToolbarDesktop from './IndemnitesToolbarDesktop'
import FilterDemandesMobile from '../Includes/Filter/FilterDemandesMobile'
import FilterDemandesDesktop from '../Includes/Filter/FilterDemandesDesktop'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Paper
} from '@mui/material'
import {
  properties
} from '../../Settings/Indemnites'
import {
  SET_FILTERS_PAGE
} from '../../Redux/Actions/Filters'

const IndemnitesContent = ({
  data,
  total
}) => {
  const dispatch = useDispatch()
  const [page, setPage] = React.useState(0)
  const [filter, setFilter] = React.useState(false)
  const device = useSelector(state => state.device)
  const notification = useSelector(state => state.notifications.notification)
  return (
    <>
      {
        (device.mobile)
          ? <IndemnitesToolbarMobile
              setPage={setPage}
              setFilter={setFilter}
            />
          : null
      }
      <Paper>
        {
          (device.desktop)
            ? <IndemnitesToolbarDesktop/>
            : null
        }
        {
          (total > 0)
            ? <>
                {
                  (notification === '')
                    ? (device.mobile)
                      ? <FilterDemandesMobile
                          open={filter}
                          page="indemnites"
                          label="indemnités"
                          setOpen={setFilter}
                          Commit={(state) => {
                            setPage(0)
                            dispatch(SET_FILTERS_PAGE('indemnites', state))
                          }}
                        />
                      : <FilterDemandesDesktop
                          page="indemnites"
                          setPage={setPage}
                        />
                    : null
                }
                <TableData
                  data={data}
                  page={page}
                  setPage={setPage}
                  titre={IndemnitesMobileTitre}
                  pagination={(
                    (data.length > 0) &&
                    (notification === '')
                  )}
                  {...properties}
                />
              </>
            : null
        }
      </Paper>
    </>
  )
}

export default IndemnitesContent
